import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { CreateUpdateEntries, EntityIdObject, EntityObject } from "../../../common/types";
import {
  BusinessCoefficientsReportFilterExportRequest,
  BusinessCoefficientsReportFilterPageRequest,
  BusinessCoefficientsReportFilterPageResult,
  CreateUpdateProductCommissionsSettings,
  ProductCommissionsSettings,
  ProductCommissionsSettingsBusinessCoefficients,
} from "./types";

const UPDATE_PRODUCT_COMMISSIONS_SETTINGS = ApiRequestAdapter.create(
  "/products/{0}/commissions-settings",
  HttpMethod.PUT,
);
const GET_PRODUCT_BUSINESS_COEFFICIENTS = ApiRequestAdapter.create(
  "/products/{0}/commissions-settings/business-coefficients",
  HttpMethod.GET,
);
const FILTER_BUSINESS_COEFFICIENTS_REPORT = ApiRequestAdapter.create(
  "/products/commissions-settings/business-coefficients-report",
  HttpMethod.POST,
);
const DOWNLOAD_BUSINESS_COEFFICIENTS_EXPORT = ApiRequestAdapter.create(
  "/products/commissions-settings/business-coefficients-report/export",
  HttpMethod.POST,
);

export const productCommissionsSettingsApi = {
  createUpdateProductCommissionsSettings: (
    request: EntityObject<CreateUpdateEntries<CreateUpdateProductCommissionsSettings>>,
  ): AxiosPromise<ProductCommissionsSettings[]> => {
    return apiService.put(UPDATE_PRODUCT_COMMISSIONS_SETTINGS.getParametrizedUrl(request.id), request.object);
  },
  getProductBusinessCoefficients: (
    request: EntityIdObject,
  ): AxiosPromise<ProductCommissionsSettingsBusinessCoefficients[]> => {
    return apiService.get(GET_PRODUCT_BUSINESS_COEFFICIENTS.getParametrizedUrl(request.id));
  },
  filterBusinessCoefficientsReport: (
    request: BusinessCoefficientsReportFilterPageRequest,
  ): AxiosPromise<BusinessCoefficientsReportFilterPageResult> => {
    return apiService.post(FILTER_BUSINESS_COEFFICIENTS_REPORT.url, request);
  },
  downloadBusinessCoefficientsExport: (request: BusinessCoefficientsReportFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.post(DOWNLOAD_BUSINESS_COEFFICIENTS_EXPORT.url, request, { responseType: "blob" });
  },
};

export const DEFAULT_BUSINESS_COEFFICIENTS_REPORT_QUERY_PARAMS: Required<BusinessCoefficientsReportFilterPageRequest> =
  {
    pageIndex: 0,
    pageSize: PageSizes.LARGE,
    keyword: "",
    institutionIds: [],
    productGroupIds: [],
    commissionKinds: [],
  };
